import { useEffect, useState } from 'react';
import { loadGooglePlacesApi } from 'components/LocationSelect/utils/api-loader';

export const useGooglePlacesAutocomplete = () => {
  const [sessionToken, setSessionToken] = useState();
  const [autocompleteService, setAutocompleteService] = useState();
  const [placesService, setPlacesService] = useState();

  const initPlaces = async () => {
    /* eslint-disable no-undef */
    setSessionToken(new google.maps.places.AutocompleteSessionToken());
    setAutocompleteService(new google.maps.places.AutocompleteService());
    setPlacesService(new google.maps.places.PlacesService(document.createElement('div')));
    /* eslint-enable no-undef */
  };

  useEffect(() => {
    if (!document.querySelector('#google-places-api')) {
      loadGooglePlacesApi(initPlaces);
    } else {
      initPlaces();
    }
  }, []);

  return { sessionToken, autocompleteService, placesService };
};
